import { render, staticRenderFns } from "./PrefixAnnouncements.vue?vue&type=template&id=378e3390"
import script from "./PrefixAnnouncements.vue?vue&type=script&lang=js"
export * from "./PrefixAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports